export default __webpack_public_path__ + "static/media/poster_save_e.f02ca7d4.jpg";